import React, { useState } from 'react'

import { FormControlLabel, Radio, RadioGroup, Typography } from '@material-ui/core'
import { NonDismissibleDialog } from '@scoir/modals'
import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'

import features from 'common/college-features'
import permissions from 'common/system-permissions'
import { isFeatureEnabled } from 'store/college'
import { hasPermission } from 'store/user'

import RequestFeatureAccessModal from './RequestFeatureAccessModal'
import RequestPermissionModal from './RequestPermissionModal'

const { Body, Footer } = NonDismissibleDialog
const { CloseButton, PrimaryActionButton } = Footer

const SelectMessageTypeModal = ({ show, onHide, onNext }) => {
  const [messageType, setMessageType] = useState('One-Time')
  const enabled = useSelector((store) => isFeatureEnabled(store, features.SUPPORTS_STUDENT_OUTREACH))
  const allowed = useSelector((store) => hasPermission(store, permissions.MANAGE_COLLEGE_OUTREACH_MESSAGES))

  if (!enabled) {
    return (
      <RequestFeatureAccessModal
        feature={features.SUPPORTS_STUDENT_OUTREACH}
        show={show}
        onHide={onHide}
      />
    )
  }

  if (!allowed) {
    return (
      <RequestPermissionModal
        role={permissions.MANAGE_COLLEGE_OUTREACH_MESSAGES}
        show={show}
        onHide={onHide}
      />
    )
  }

  return (
    <NonDismissibleDialog
      open={show}
      onClose={onHide}
      headerText="Select Message Type"
    >
      <Body>
        <RadioGroup
          aria-label="select a one time or automated message type"
          name="message-type"
          value={messageType}
          onChange={(e) => {
            setMessageType(e.target.value)
          }}
        >
          <FormControlLabel
            label={
              <>
                <Typography>One Time Message</Typography>
                <Typography
                  variant="body2"
                  color="textSecondary"
                >
                  Messages sent once to a selection of your student audience.
                </Typography>
              </>
            }
            value="One-Time"
            control={<Radio color="primary" />}
          />
          <FormControlLabel
            label={
              <>
                <Typography>Automated Message</Typography>
                <Typography
                  variant="body2"
                  color="textSecondary"
                >
                  Messages sent automatically based on student actions.
                </Typography>
              </>
            }
            value="Automated"
            control={<Radio color="primary" />}
          />
        </RadioGroup>
      </Body>
      <Footer>
        <CloseButton>Cancel</CloseButton>
        <PrimaryActionButton onClick={() => onNext(messageType)}>Next</PrimaryActionButton>
      </Footer>
    </NonDismissibleDialog>
  )
}

SelectMessageTypeModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  onNext: PropTypes.func.isRequired,
}

export default SelectMessageTypeModal
